import React from "react";
import { IconContext } from "react-icons";

import { FaBars } from "react-icons/fa";

import "./Navbar.css";

const Navbar = ({ sideBarState, setSideBarState }) => {
  return (
    <IconContext.Provider value={{ size: "32px" }}>
      <div
        className=" shadow-lg z-50  bg-primary-color flex justify-between h-[10vh] w-full top-0  "
        id="navbar"
      >
        <div className="icon containa">NKWETACHA TERENCE</div>
      </div>
    </IconContext.Provider>
  );
};

export default Navbar;
